import React from "react";

interface TeamFormData {
  matchId: number;
  matchday: number;
  result: "W" | "L" | "D";
  isHome: boolean;
  teamScore: number;
  opponentScore: number;
  kickoffTime: string;
}

interface TeamFormIconsProps {
  teamId: number;
  formData: TeamFormData[];
}

const colorMap: Record<string, string> = {
  W: "var(--app-score-diff)",
  L: "var(--app-score-wrong)",
  D: "var(--ion-color-medium)",
};

const TeamFormIcons: React.FC<TeamFormIconsProps> = ({ teamId, formData }) => {
  if (!formData || formData.length === 0) return null;

  return (
    <div style={{ display: "flex", gap: "3px", justifyContent: "center", marginTop: "6px", flexWrap: "wrap", alignItems: "center" }}>
      {formData.map((match, index) => {
        const c = colorMap[match.result] || colorMap.D;
        return (
          <div
            key={`${teamId}-${match.matchId}-${index}`}
            style={{
              fontSize: "10px",
              fontWeight: 700,
              color: c,
              backgroundColor: `color-mix(in srgb, ${c} 15%, transparent)`,
              border: `1px solid ${c}`,
              borderRadius: "50%",
              width: "16px",
              height: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            title={`Matchday ${match.matchday}: ${match.teamScore}-${match.opponentScore} ${match.isHome ? "(H)" : "(A)"}`}
          >
            {match.result}
          </div>
        );
      })}
    </div>
  );
};

export default TeamFormIcons;
